import * as types from './types';
import postQuery from '../queries/post';
import userPostHitQuery from '../queries/userPostHit';
import relatedClassesQuery from '../../../Index/queries/relatedClasses';
import router from '../../../../router';

export const fetchPostData = ({ commit, dispatch, rootState }) => {
  const currentSlug = rootState.route.params.slug;
  if (!currentSlug) return dispatch('fetchNextPost');

  return postQuery.bySlug(currentSlug)
    .then((response) => {
      const post = response.data.by_slug;
      commit(types.SET_ACTIVE_POST, post);
      dispatch('registerPostHit', post.user_post.id);
    });
};

export const fetchNextPost = () =>
 relatedClassesQuery.fetch()
  .then((response) => {
    const { data } = response;
    const nextPost = data.related_classes[0].post;

    router.push({ name: 'class', params: { slug: nextPost.slug } });
  });

export const registerPostHit = ({ commit }, userPostId) => {
  userPostHitQuery.create(userPostId)
    .then((response) => {
      const { data } = response;
      const { createUserPostHit } = data;
      commit(types.SET_USER_POST_HIT, createUserPostHit.user_post_hit.id);
    });
};

export const updatePostHit = ({ state }) => {
  const { userPostHit } = state;

  if (!userPostHit.id) {
    return;
  }

  userPostHitQuery.update(userPostHit.id);
};

export const checkIfCanBeAccessed = ({ _ }, slug) => postQuery.checkIfCanBeAccessed(slug);



// WEBPACK FOOTER //
// ./src/screens/Class/Index/store/actions.js